import {Component} from "@angular/core";
import {ReportModel} from "@fedeltapointofsale/data-client";
import {EditService} from "../../../framework/entity/edit/edit-page/edit.service";

@Component({
    selector: "wbo-detail-report-criteria",
    templateUrl: "./detail-report-criteria.component.html"
})
export class DetailReportCriteriaComponent {

    constructor(public model: ReportModel<any>, public editService: EditService) {
    }
}
